import React from "react";
import { useIntl } from "react-intl";
import NoData from "./NoData";

const NoSessionData = ({ children, data }) => {
  const intl = useIntl();

  return (
    <NoData
      data={data}
      message={intl.formatMessage({
        id: "Shared.NoSessionData.NoSession",
        defaultMessage: "There are no sessions. Please check later for new contents..."
      })}
    >
      {children}
    </NoData>
  );
};

export default NoSessionData;
